import React from 'react';
import { PieChart as BasePieChart } from '../../../../CommonComponents/OPL/charts/PieChart/PieChart';
import { Dot } from '../../../../CommonComponents/OPL/Dot/Dot';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { formatPercentage } from '../../../../CommonUtils/formatNumber';
import { AssetAllocation } from '../../../../CommonUtils/getAssetColors';
import { WrapperProps } from '../../../../CommonComponents/OPL/Wrapper/Wrapper';

interface Props extends WrapperProps {
  assetAllocation: AssetAllocation[];
}

export const PieChart: React.FC<Props> = ({ assetAllocation }) => {
  return (
    <Box display="flex" mt="32" mb="auto">
      <Box display="flex" flex={1} alignItems="center" justifyContent="center">
        <Box height={250} width={250}>
          <BasePieChart
            customSettings={{
              plotOptions: {
                pie: {
                  innerSize: '75%',
                },
              },
            }}
            series={[
              {
                data: assetAllocation,
              },
            ]}
          />
        </Box>
      </Box>

      <Box
        as="ul"
        alignItems="center"
        css="list-style-type: none"
        display="flex"
        justifyContent="center"
        flex={1}
        flexDirection="column"
        pl="40"
      >
        {assetAllocation.map(({ name, y, color }) => (
          <Box
            as="li"
            alignItems="center"
            display="flex"
            justifyContent="space-between"
            width="100%"
            mb="16"
            key={name}
          >
            <Box display="flex" alignItems="center">
              <Dot bg={color} mr="12" />
              <Text fontWeight={500} color="neutral.700">
                {name}
              </Text>
            </Box>
            <Text variant="tabular" fontWeight={500} color="neutral.700">
              {formatPercentage(y)}
            </Text>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
